export const selectFilesData = (state) => state.files.data;
export const selectFilesStatus = (state) => state.files.status;
export const selectFilesError = (state) => state.files.error;